import {LiveChart} from "./live-chart";
import {initializeMultiItemCarousels} from "../functions/initializeMultiItemCarousels";

var MetalPriceRatios = function(chartData) {
    var isChartUpdating = false;
    var xhr;

    var livePricesChart = new LiveChart(chartData);
    var summaryTable = $('#summary-table');

    var chartLoader = $('.chart-loader');
    var summaryLoader = $('.summary-loader');

    this.updateChart = function(manual) {
        var form = $('#metal-price-ratios-form');
        var url = form.attr('action');
        var data = form.serialize();

        // cancel existing ajax request
        if (manual == true && xhr && xhr.readyState != 4) {
            xhr.abort();
            isChartUpdating = false;
        }

        // check if request has completed before making a new request
        if (!isChartUpdating) {
            isChartUpdating = true;

            if (manual == true) {
                // show loader
                chartLoader.fadeIn();
                summaryLoader.fadeIn();
            }

            xhr = $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: data,
                success: function(response) {
                    processChartUpdate(response.chart_data, manual);
                    processSummaryUpdate(response.summary, manual);

                    processContentUpdate(
                        response.top_selling_products,
                        response.content,
                        response.related_blog_articles,
                        manual);

                    isChartUpdating = false;
                }
            });
        }
    };

    function processChartUpdate(chartData, manual) {
        var chart = livePricesChart.myChart;

        chart.series[0].options.name = chartData.title;
        chart.series[0].options.color = chartData.colors.colorRgba;
        chart.tooltip.options.valuePrefix = chartData.symbol;
        chart.series[0].update(chart.series[0].options);
        chart.xAxis[0].update({
            type: 'datetime'
        });
        chart.yAxis[0].update({
            labels: {
                formatter: function () {

                    var digits = livePricesChart.getDigits(this.value);

                    var value = this.value.toFixed(digits);

                    if (chartData.symbol !== '') {
                        return chartData.symbol + value;
                    }
                    else {
                        return value;
                    }

                }
            }
        });
        chart.series[0].setData(chartData.data, true);
        if (manual == true) {
            // hide loader
            chart.xAxis[0].setExtremes(
                chart.xAxis[0].dataMin,
                chart.xAxis[0].dataMax
            );
            $( 'input.highcharts-range-selector', $(chart.container).parent() ).datepicker( "option", "minDate", new Date(chart.xAxis[0].dataMin) );
            $( 'input.highcharts-range-selector', $(chart.container).parent() ).datepicker( "option", "maxDate", new Date(chart.xAxis[0].dataMax) );
            chartLoader.fadeOut();
        }
    }

    function processSummaryUpdate(summary, manual) {
        var currentValue = summaryTable.find('.current .text');
        var highValue = summaryTable.find('.high .text');
        var lowValue = summaryTable.find('.low .text');
        var changeValue = summaryTable.find('.change .text');

        if (manual == true) {
            // hide loader
            summaryLoader.fadeOut();
        }

        // update summary table values
        currentValue.text(summary.current);
        highValue.text(summary.high);
        lowValue.text(summary.low);
        changeValue.text(summary.change)
        changeValue.removeClass('negative positive').addClass(summary.changeType);
    }

    function processContentUpdate(top_selling_products, content, related_blog_articles, manual) {
        if (manual == true) {
            var h1_title = $('.live-chart-row h1');
            var meta_title = $('title');
            var meta_description = $('meta[name=description]');
            var description = $('.content .main');

            h1_title.text(content.h1_title);
            meta_title.text(content.meta_title);
            meta_description.attr('content', content.meta_description);

            if (typeof top_selling_products == 'undefined') {
                top_selling_products = ''
            }
            if (typeof content.description == 'undefined') {
                content.description = ''
            }
            if (typeof related_blog_articles == 'undefined') {
                related_blog_articles = ''
            }

            top_selling_products = '<section>' + top_selling_products + '</section>';
            related_blog_articles = '<section>' + related_blog_articles + '</section>';

            description.html(top_selling_products + content.description + related_blog_articles);

            initializeMultiItemCarousels()

            history.replaceState({"html":content.url}, content.meta_title, content.url);
        }
    }
};

global.MetalPriceRatios = MetalPriceRatios;

export {MetalPriceRatios};